import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  menuItemRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  refreshDateLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  refreshIconContainer: {
    marginLeft: 20,
  },
}));

export default useStyles;
